import React from "react";
import {Controls} from "./controls/Controls";
import {ProgressSlider, ProgressSliderProps} from "./progressSlider/ProgressSlider";
import {useBreakpoint} from "../../../../../hooks/useBreakpoint";

import styles from "./Controller.module.scss";


export interface ControllerProps extends ProgressSliderProps {
    length?: number
    isFullScreen: boolean;
}

export const Controller: React.FC<ControllerProps> = ({getPlayerCurrentTime, isFullScreen}) => {
    const screen = useBreakpoint();
    const isDesktop = screen === 'desktop';

    const showProgress = isDesktop || isFullScreen;

    return (
        <div>
            <Controls minimalView={!isDesktop} isFullScreen={isFullScreen}/>
            <ProgressSlider
                getPlayerCurrentTime={getPlayerCurrentTime}
                isFullScreen={isFullScreen}
                className={showProgress ? '' : styles.invisibleProgress}
            />
        </div>
    );
};

